export enum TableType {
  ADDRESS = 'Endereço',
  CREDENTIAL = 'Credencial',
  PEOPLE = 'Pessoa',
  DOCUMENT = 'Documento',
  USER = 'Usuário',
}
